<template>
    <div class="primary-nav-section" style="background-color: #000 !important;border-right: 1px solid #ffffff;">
        <div class="container">
            <ul class="nav primary clone-main-menu newcolorblue" id="mercado_main" data-menuname="Produtos">
                <li class="menu-item menu-item-has-children item-megamenu stylebluegerador"
                    v-for="(item, index) in this.dataMenu"
                    :key="index" v-bind:class="item.Descricao == 'GERADOR DE ENERGIA SOLAR FOTOVOLTAICO' ? 'menu-item menu-item-has-children item-megamenu stylebluegerador' : 'menu-item menu-item-has-children item-megamenu stylebluenormal'" >
                    <a :href="`${$SiteUrl}/loja/categoria/${item.Slug}`"
                       v-bind:title="item.Descricao"

                       class="link-term mercado-item-title" style="background-color: #000;">{{item.Descricao}}</a>

                    <div class="wrap-megamenu">
                        <div :class="`megamenu-content min-height-526 ${item.Slug}-banner`">
                            <div class="row flex-row" v-if="item.Slug == 'energia-solar'">
                                <div :class="['col-xs-12 col-md-3',index == 1 ? 'bg-cinza-leve' : '']" v-for="(itemMenu, index) in item.ItensMenu" :key="index">
                                    <div class="wrap-vertical-nav">
                                        <!--<span class="menu-title">{{itemMenu.Descricao}}</span>-->
                                        <MultiLevelMenu :menuItems="itemMenu.ItensMenu" classes="menu-small" v-if="index == 0" :icone="false" />
                                        <MultiLevelMenu :menuItems="itemMenu.ItensMenu"
                                                        v-else
                                                        classes="menu-small"
                                                        :icone="true" />
                                    </div>
                                </div>

                                <!-- <div class="xs-hidden col-md-6">
                                  <a href="#">
                                    <img src="https://www.aldo.com.br/images-seg/menu-energia-solar.jpg" />
                                  </a>
                                </div> -->
                            </div>
                            <div class="row flex-row" v-else>
                                <!-- {{item.ItensMenu}} -->
                                <div :class="[valida(index, item.ItensMenu.length), item.Slug == 'energia-solar']"
                                     v-for="(item, index) in item.ItensMenu"
                                     :key="index">

                                    <div class="wrap-vertical-nav">

                                        <!--<span class="menu-title">{{item.Descricao}}</span>-->
                                        <MultiLevelMenu :menuItems="item.ItensMenu" classes="menu-small" :icone="true" />
                                    </div>
                                </div>

                                <!-- <div class="xs-hidden col-md-6">
                                  <a v-if="item.Slug == 'drones'" :href="item.Slug">
                                    <img src="https://www.aldo.com.br/images-seg/menu-drone.jpg" />
                                  </a>
                                  <a v-if="item.Slug == 'informatica'" :href="item.Slug">
                                    <img src="https://www.aldo.com.br/images-seg/menu-informatica.jpg" />
                                  </a>
                                </div> -->

                            </div>
                        </div>
                    </div>
                </li>
                <li class="menu-item menu-item-has-children item-megamenu stylebluegerador" >
                    <a :href="`/loja/personalizacao-gerador`" title="Personalize seu Gerador" class="link-term mercado-item-title" style="background-color: #000;">
                        Personalize seu Gerador
                        <span class="badge" style="background-color: red">NOVO</span>
                    </a>
                </li>
                <li class="menu-item menu-item-has-children item-megamenu service_menu" >
                    <ul class="nav primary clone-main-menu toggle-slide-menu" id="mercado_main_servicos" data-menuname="Servi&ccedil;os">
                        <li class="menu-item menu-item-has-children item-megamenu azulmenu40">
                            <a href="#" title="Servicos" class="link-term mercado-item-title" style="background-color: #000;">Servi&ccedil;os</a>
                            <div class="wrap-megamenu">
                                <div class="megamenu-content" style="padding: 8px 15px 6px; background-image:none">
                                    <div class="row">
                                        <div class="col-md-12 col-lg-12">
                                            <div class="wrap-vertical-nav">
                                                <ul data-menuname="menuservicos" id="menuservicos" style="margin:0 !important">
                                                    <li class="menu-item"><a style="padding:8px" rel="noreferrer" target="_blank" :href="`${$SiteUrl}/portais/financiamento-energia-solar`" class="link-term">Financiamento Energia Solar</a></li>
                                                    <li class="menu-item"><a style="padding:8px" rel="noreferrer" target="_blank" :href="calcLink" class="link-term">{{calcName}}</a></li>
                                                    <li class="menu-item"><a style="padding:8px" rel="noreferrer" :href="`${$SiteUrl}/loja/campanhas`" target="_blank" class="link-term">Campanhas</a></li>
                                                    <li class="menu-item"><a style="padding:8px" rel="noreferrer" :href="`${$SiteUrl}/loja/marcas`" class="link-term" target="_blank">Parceiros</a></li>
                                                    <li class="menu-item"><a style="padding:8px" rel="noreferrer" target="_blank" :href="`${$SiteUrl}/portais/venda-direta`" class="link-term">Venda Direta</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
    </div>
</template>

<!-- <style scoped>
    .energia-solar-banner {
        background-image: url(https://app.aldo.com.br/images-seg/menu-energia-solar-new.jpg?version=20210927) !important;
        background-repeat: no-repeat;
        background-position:center;
    }

    .drones-banner {
        background-image: url(https://app.aldo.com.br/images-seg/menu-energia-solar-new.jpg?version=20210927) !important;
        background-repeat: no-repeat;
        background-position:center;
    }

    .informatica-banner {
        background-image: url(https://app.aldo.com.br/images-seg/menu-energia-solar-new.jpg?version=20210927) !important;
        background-repeat: no-repeat;
        background-position:center;
    }


</style> -->

<script>
    import MultiLevelMenu from "./MultiLevelMenu.vue";
    import axios from "axios";

    export default {
        name: "MenuSegments",
        components: {
            MultiLevelMenu
        },
        data() {
            return {
                dataMenu: [],
                calcLink: "https://calculadorasolar.aldo.com.br/",
                calcName: "Calculadora Solar",
            };
        },
        mounted() {
            const self = this;
            setTimeout(function () {
                let session = JSON.parse(localStorage.getItem('usuarioLogado'));
                if (session && session.DadosCliente != null) {
                    if (session.DadosCliente.TipoUsuario == 2) {
                        self.calcLink = `${self.$SiteUrl}/calculadora-aldo-solar/gestao/dashboard`;
                        self.calcName = "Calculadora Aldo Solar";
                    } else {
                        self.calcLink = `${self.$SiteUrl}/calculadora-aldo-solar/revenda/dashboard`;
                        self.calcName = "Propostas Comerciais";
                    }

                }
            }, 1000);

        },
        created() {
            if (!this.tempoMenuExpirou()) {
                this.dataMenu = JSON.parse(localStorage.listMenus);
            } else {
                const api = axios.create({
                    withCredentials: false,
                })
                api.get(this.$apiUrl + "Home.svc/listmenus")
                    .then(response => {
                        this.dataMenu = response.data;
                        localStorage.listMenus = JSON.stringify(response.data);
                        localStorage.listMenuExpires = new Date().getTime()

                        // // console.log("dataMenu", this.dataMenu)
                        // // console.log("storage", localStorage)
                    })
                    .catch(response => {
                        // console.log(response);
                    });
            }


        },
        methods: {
            valida: function (valor, lista) {
                if (lista > 9) {
                    return "col-md-6";
                } else {
                    return "col-md-3";
                }
            },

            tempoMenuExpirou: function() {

                const expireTIme = 6 * 60 * 60;

                if (!localStorage.listMenus || !localStorage.listMenuExpires) {
                    return true;
                }

                const time = new Date().getTime();
                const lastTime = localStorage.listMenuExpires;
                const diff = time - lastTime;

                const seconds = this.msToSeconds(diff)

                return seconds > expireTIme;
            },

            msToSeconds: function (ms) {
                var seconds = ms / 1000;

                return seconds;
            }
        }
    };
</script>
